import { styled } from "goober";
import { PressButton } from "./PressButton";

export const ClearButton = styled(PressButton)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: var(--text-primary);
  opacity: 0.3;
  &:hover {
    opacity: 1;
  }
`;
